import { FormikState, FormikHandlers, FormikHelpers } from 'formik';
import React, { useCallback } from 'react';

import { AutocompleteField } from '../autocomplete-field';
import { Value } from '../autocomplete-field/AutocompleteField';

type AutocompleteFieldProps = React.ComponentProps<typeof AutocompleteField>;

type Props = Omit<AutocompleteFieldProps, 'value' | 'onChange' | 'error' | 'helperText' | 'defaultValue' | 'name'> & {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formik: FormikHandlers & FormikState<any> & FormikHelpers<any>;
  name: string;
  onValueChange?: AutocompleteFieldProps['onChange'];
};

const FormikAutoCompleteField: React.FC<Props> = (props: Props) => {
  const { name, formik, onValueChange, ...rest } = props;
  const meta = formik.getFieldMeta<Value>(name);

  const handleChange: NonNullable<AutocompleteFieldProps['onChange']> = useCallback(
    (value) => {
      const newValue = value || '';
      void formik.setFieldValue(name, newValue);
      onValueChange?.(newValue);
    },
    [formik, name, onValueChange],
  );

  return (
    <AutocompleteField
      {...rest}
      name={name}
      value={meta.value}
      onChange={handleChange}
      error={meta.touched && !!meta.error}
      helperText={meta.touched && meta.error}
    />
  );
};

export { FormikAutoCompleteField };
